import { render, staticRenderFns } from "./CaseForm.vue?vue&type=template&id=24a995b3"
import script from "./CaseForm.vue?vue&type=script&lang=js"
export * from "./CaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports